import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { VexUserProfile } from '@pharvio/core/ui';
import { AuthState, Logout } from '@pharvio/accounts/admin-account/data-access';
import { APP_ROUTES } from '../../app-routes';

const ROLE_LABELS: Record<string, string> = {
  super_admin: 'Super Admin',
  pharmacist: 'Pharmacist',
  cashier: 'Cashier',
  inventory_manager: 'Inventory Manager',
  accountant: 'Accountant',
  branch_manager: 'Branch Manager'
};

@Injectable({ providedIn: 'root' })
export class VexUserProfileService implements VexUserProfile {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  readonly name$: Observable<string> = this.store
    .select(AuthState.currentUser)
    .pipe(
      map((user) => (user ? `${user.firstName} ${user.lastName}`.trim() : ''))
    );

  readonly role$: Observable<string> = this.store
    .select(AuthState.currentUser)
    .pipe(
      map((user) => {
        const userRoles = user?.roles ?? [];
        if (userRoles.length === 0) {
          return 'No Role';
        }
        // sort roles by predefined hierarchy
        const sortedRoles = userRoles.sort((a, b) => {
          const aIndex = Object.keys(ROLE_LABELS).indexOf(a);
          const bIndex = Object.keys(ROLE_LABELS).indexOf(b);
          return aIndex - bIndex;
        });
        // return label of highest priority role
        return ROLE_LABELS[sortedRoles[0]] ?? sortedRoles[0];
      })
    );

  logout(): void {
    this.store
      .dispatch(new Logout())
      .pipe(take(1))
      .subscribe(() => {
        this.router.navigate([APP_ROUTES.Auth]);
      });
  }
}
